export default {
  name: "banner",
  props:['sale']
}